// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__UTfxI","label":"SetPasswdForm_label__2GDWm"};